import { Action } from '@ngrx/store'
import * as CompoundSettingsTypes from './compound-settings.types'
import { CompoundSettings } from './compound-settings.interface'

export class FetchCompoundSettingsRequest implements Action {
  readonly type = CompoundSettingsTypes.FETCH_COMPOUND_SETTINGS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchCompoundSettingsSuccess implements Action {
  readonly type = CompoundSettingsTypes.FETCH_COMPOUND_SETTINGS_SUCCESS
  constructor(public payload: CompoundSettings) {}
}

export class FetchCompoundSettingsFailure implements Action {
  readonly type = CompoundSettingsTypes.FETCH_COMPOUND_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateCompoundSettingsRequest implements Action {
  readonly type = CompoundSettingsTypes.UPDATE_COMPOUND_SETTINGS_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateCompoundSettingsSuccess implements Action {
  readonly type = CompoundSettingsTypes.UPDATE_COMPOUND_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdateCompoundSettingsFailure implements Action {
  readonly type = CompoundSettingsTypes.UPDATE_COMPOUND_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = CompoundSettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = CompoundSettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateCompoundSettingsRequest
  | UpdateCompoundSettingsSuccess
  | UpdateCompoundSettingsFailure
  | FetchCompoundSettingsSuccess
  | FetchCompoundSettingsFailure
  | FetchCompoundSettingsRequest
  | SetDefaultData
  | UpdateField
